import gql from 'graphql-tag';

/**
 * Data of the block project-base-configuration (ADR 0006 D1): what `SolarPlantItems` shows.
 * Read through `Project.blocks.baseConfiguration`, which checks the block's read permission.
 */
export const PROJECT_BASE_CONFIGURATION_FIELDS = gql`
  fragment projectBaseConfigurationFields on ProjectBaseConfigurationBlock {
    id
    number
    solarPlant {
      emergencyPowerState
      assignedItemPackages {
        itemPackage {
          number
          name
        }
        addedBy {
          firstname
          lastname
        }
        createdAt
      }

      solarPanels {
        item {
          _id
          number
          description
          solarPanel {
            number
            manufacturer
            type
            power
          }
        }
        count
      }

      inverters {
        item {
          _id
          number
          description
          inverter {
            number
            manufacturer
            type
            nominalPower
            nominalVoltage
            apparentPower
            activePower
            ratedCurrent
            shortCircuitCurrent
            nominalDcPower
            allowedChargeDischargeCurrent
            gridAndPlantProtectionIntegrated
            gridAndPlantProtectionType
          }
        }
        count
      }

      batteries {
        item {
          _id
          number
          description
          battery {
            id
            number
            manufacturer
            type
            capacity
            dischargePower
            batteryModuleCount
            batteryModuleCapacity
            usableCapacity
            ratedVoltage
            connectionType
          }
        }
        count
      }

      wallboxes {
        item {
          _id
          number
          description
          wallbox {
            id
            number
            manufacturer
            type
            maxNetInputPower
            maxNetOutputPower
            minChargingPower
            maxChargingPower
            activePowerControllable
            chargingType
            shiftFactorCosphiType
            connectionType
            connectionTypes
          }
        }
        count
      }

      energyFlowDirectionSensorItem {
        _id
        number
        description
        energyFlowDirectionSensor {
          id
          number
          manufacturer
          type
        }
      }
    }
  }
`;
